import {
    SET_FORM_TEMPLATES_LIST,
    SET_LOADING,
    SET_FORM_TYPE,
    SET_TEMPLATES,
    SET_ERROR,
    SET_FORM_STATE,
    SET_FORM_STATE_ERRORS,
    SET_ALERT,
    SET_FORM_INFO,
    SET_FORM_SIGNATORIES,
    SET_USER_DETAILS,
    SET_AGENT_DETAILS,
    SET_ALL_AGENT_NAMES,
    SET_PARTIES_FIELDS,
    SET_SUPPORTING_DOCS,
    SET_SHARED_FORMS,
    RESET_FORM_STATE
} from './types';


export const setFormTemplatesList = (value) => ({
    type: SET_FORM_TEMPLATES_LIST,
    payload: value
})

export const setFormTypeField = (value) => ({
    type: SET_FORM_TYPE,
    payload: value
})

export const setTemplatesField = (value = []) => ({
    type: SET_TEMPLATES,
    payload: value
})

export const setFormState = (value) => ({
    type: SET_FORM_STATE,
    payload: value
})

export const setFormErrors = (value) => ({
    type: SET_FORM_STATE_ERRORS,
    payload: value
})

export const isLoading = (value) => ({
    type: SET_LOADING,
    payload: value
})

export const isError = (value) => ({
    type: SET_ERROR,
    payload: value
})

export const setAlert = (value) => ({
    type: SET_ALERT,
    payload: value
})

export const setFormInfo = (value) => ({
    type: SET_FORM_INFO,
    payload: value
})

export const setFormSignatories = (value) => ({
    type: SET_FORM_SIGNATORIES,
    payload: value
})
export const setUserDetails = (value) => ({
    type: SET_USER_DETAILS,
    payload: value
})
export const setAgentDetails = (value) => ({
    type: SET_AGENT_DETAILS,
    payload: value
})
export const setAllAgentNames = (value) => ({
    type: SET_ALL_AGENT_NAMES,
    payload: value
})
export const setPartiesFields = (value) => ({
    type: SET_PARTIES_FIELDS,
    payload: value
})
export const setSupportingDocs = (value) => ({
    type: SET_SUPPORTING_DOCS,
    payload: value
})
export const setSharedForms = (value) => ({
    type: SET_SHARED_FORMS,
    payload: value
})
export const resetFormState = () => ({
    type: RESET_FORM_STATE,
})


